import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button } from "antd";

export const CustomerBackButton = () => {
    return (
        <>
            <Button type="text" className="mr-4" href="/account-home" icon={<ArrowLeftOutlined />} />
        </>
    )
};